import { render, staticRenderFns } from "./LoginDilogComponent.vue?vue&type=template&id=5c4d49f2&"
import script from "./LoginDilogComponent.vue?vue&type=script&lang=js&"
export * from "./LoginDilogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QLinearProgress} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QLinearProgress}, component.options.components || {})
